import { renderApiServer } from "../message/APIProxy.render.server";
import * as packageJSON from "../../package.json";

renderApiServer.project.getVersion.onRequest(() => {
  console.log("#renderApiServer.project.getVersion.onRequest");
  return packageJSON.version;
});
